import React from 'react';
import MultiCarousel from 'react-multi-carousel';

// APLICAÇÕES EM QUE UTILIZA NEXT APARENTEMENTE
// NAO ACEITAM A IMPORTAÇÃO DENTRO DO COMPONENTE EM SI
// DESSA FORMA ESSE CODIGO DEVE SER IMPORTADO DENTRO DO _app.js
// import 'react-multi-carousel/lib/styles.css';

// INTERFACES
import { ICarousel } from '../../interfaces/Carousel.interface';

const Carousel: React.FC<ICarousel> = ({
  arrows = false,
  autoPlay = false,
  autoPlaySpeed = 3000,
  buttons,
  centerMode = false,
  children,
  draggable = true,
  infinite = true,
  keyBoardControl = false,
  partialVisible = false,
  responsive,
  showDots = false,
  ssr = true,
  swipeable = true
}): JSX.Element => {
  return (
    <MultiCarousel
      partialVisible={partialVisible}
      arrows={arrows}
      autoPlay={autoPlay}
      autoPlaySpeed={autoPlaySpeed}
      centerMode={centerMode}
      customButtonGroup={buttons}
      draggable={draggable}
      infinite={infinite}
      keyBoardControl={keyBoardControl}
      renderButtonGroupOutside
      responsive={responsive}
      showDots={showDots}
      ssr={ssr}
      swipeable={swipeable}
    >
      {children}
    </MultiCarousel>
  );
};

export default Carousel;
